import { Box, CircularProgress } from "@mui/material";
import React from "react";

interface GlobalLoaderProps {}

export const GlobalLoader: React.FC<GlobalLoaderProps> = () => {
  return (
    <>
      <Box
        sx={{
          position: "fixed",
          width: "100vw",
          height: "100vh",
          top: 0,
          left: 0,
          zIndex: 9999,
          backgroundColor: "white",
        }}
      />
      <Box
        sx={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 10000,
        }}
      >
        <CircularProgress size={100} thickness={4} />
      </Box>
    </>
  );
};
